/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions"
import { CALL_API } from "../middleware"
import { APPROVAL_LIST, APPROVAL_LIST_SUCCESS, APPROVAL_STATUS_FILTER, APPROVAL_STATUS_FILTER_SUCCESS, ApprovalStatuFilter, CHECKER_DETAILS, CHECKER_DETAILS_SUCCESS, CHECKER_OFFLINE_PAYMENT_APPROVAL, CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS, CHECKER_ORDER_APPROVAL, CHECKER_ORDER_APPROVAL_SUCCESS, CHECKER_ORDER_DETAILS, CHECKER_ORDER_DETAILS_SUCCESS, CHECKER_PAYMENT_APPROVAL, CHECKER_PAYMENT_APPROVAL_SUCCESS, CheckerOrderApprovalReq, CheckerOrderApprovalRes, CheckerOrderDetailsReq, CheckerOrderDetailsRes, OfflinePaymentApprovalReq, OfflinePaymentApprovalRes, OrderApprovalListReq, PAYMENT_APPROVAL_LIST, PAYMENT_APPROVAL_LIST_SUCCESS, PAYMENT_DETAILS, PAYMENT_DETAILS_SUCCESS, PaymentApprovalListReq, PaymentApprovalListRes, PaymentsApprovalReq } from "../types/orderApproval";
import { OrderHistoryRes } from "../types/orderManagement";

export const getAprovalStatusFilter =
    () =>
        async (dispatch: any): Promise<ApprovalStatuFilter> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/nonMfTransactions/getApprovalStatusFilter',
                    method: 'GET',
                    types: [APPROVAL_STATUS_FILTER_SUCCESS, APPROVAL_STATUS_FILTER],
                },
            });
        };

export const getOrderApprovalList =
    (body: OrderApprovalListReq) =>
        async (dispatch: any): Promise<OrderHistoryRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/orderApprovalList`,
                    method: 'POST',
                    types: [APPROVAL_LIST_SUCCESS, APPROVAL_LIST],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getCheckOrderApproval =
    (body: CheckerOrderApprovalReq) =>
        async (dispatch: any): Promise<CheckerOrderApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/checkerOrderApproval`,
                    method: 'POST',
                    types: [CHECKER_ORDER_APPROVAL_SUCCESS, CHECKER_ORDER_APPROVAL],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getCheckOrderDetails =
    (body: CheckerOrderDetailsReq) =>
        async (dispatch: any): Promise<CheckerOrderDetailsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/getOrderDetails`,
                    method: 'POST',
                    types: [CHECKER_ORDER_DETAILS_SUCCESS, CHECKER_ORDER_DETAILS],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getCheckerDetails =
    () =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/getCheckerDetails`,
                    method: 'GET',
                    types: [CHECKER_DETAILS_SUCCESS, CHECKER_DETAILS],
                },
            });
        };


export const getPaymentApprovalList =
    (body: PaymentApprovalListReq) =>
        async (dispatch: any): Promise<PaymentApprovalListRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentApprovalList`,
                    method: 'POST',
                    types: [PAYMENT_APPROVAL_LIST_SUCCESS, PAYMENT_APPROVAL_LIST],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };

export const getPaymentDetails =
    (body: CheckerOrderDetailsReq) =>
        async (dispatch: any): Promise<CheckerOrderDetailsRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentDetails`,
                    method: 'POST',
                    types: [PAYMENT_DETAILS_SUCCESS, PAYMENT_DETAILS],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getPaymentsApproval =
    (body: PaymentsApprovalReq) =>
        async (dispatch: any): Promise<CheckerOrderApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/nonMfTransactions/paymentApproval`,
                    method: 'POST',
                    types: [CHECKER_PAYMENT_APPROVAL_SUCCESS, CHECKER_PAYMENT_APPROVAL],
                    // body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    body
                },
            });
        };


export const getOfflinePaymentApproval =
    (body: OfflinePaymentApprovalReq) =>
        async (dispatch: any): Promise<OfflinePaymentApprovalRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/transactions/offlinePaymentApproval`,
                    method: 'POST',
                    types: [CHECKER_OFFLINE_PAYMENT_APPROVAL_SUCCESS, CHECKER_OFFLINE_PAYMENT_APPROVAL],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };